import { CourseMonitoringDashboard } from "components/monitoring/CourseMonitoringDashboard";

export default function Page() {
  return <CourseMonitoringDashboard />;
}
